<template>
  <div>
    <!--<b-list-group >
      這裡是統計管理
    </b-list-group>
    <b-form-input type="text" v-model="FilterPI" placeholder="輸入篩選完整PI16碼" ></b-form-input>
    <b-form-checkbox v-model="OnlySummary" :disabled="PIValidated === false" v-b-tooltip.hover title="輸入完整PI後才可勾選">不依日期統計做全部總計</b-form-checkbox>
    <b-button @click="getChartData">更新資料</b-button>-->
    <populate-form
      formTitle="API統計數據查看"
      fkey="am01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="formDataObj"
      @customValueChanged="inputChanged"
    ></populate-form>
    <div class="chart1">
      <g-chart
        type="Table"
        :data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>

import { GChart } from 'vue-google-charts'

export default {
  name: 'Statictic',
  components: {
    GChart
  },
  data: function () {
    return {
      formDataObj: {},
      filterOptions:[
        {
          componentType:'text',
          akey:'FilterPI',
          col:3,
          defaultValue:'',
          placeholder:'輸入篩選完整PI16碼'
        },
        {
          componentType:'b-form-checkbox',
          akey:'OnlySummary',
          col:3,
          defaultValue:false,
          disabled:true,
          placeholder:'不依日期統計做全部總計',
          title:"輸入完整PI後才可勾選"
        },
        {
          componentType:'b-button',
          akey:'btnqry',
          col:2,
          placeholder:'更新資料',
          execCallback:this.getChartData
        },
        {
          componentType:'span',
          col:2,
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:'同步',
          title:'強制手動同步中繼數據(請避免在2~3分間執行,排程每10分鐘會跑一次)',
          execCallback:this.forceSync
        }
      ],
      FilterPI: '',
      OnlySummary: false,
      showMsg: false,
      displayingMsg: '',
      chartData: [],
      chartOptions: {
        width: "97vw",
        height: "70vh",
        frozenRows : 1,
        frozenColumns: 1,
        /*chartArea: {
            left: 50,
            top: 50,
            height: 200
        },*/
        //axisTitlesPosition: 'none',
        /*hAxis: {
            format: 'MM/dd',
            gridlines: {
                color: '#E4E4E4',
                count: 7
            }
        },
        vAxis: {
            baselineColor: '#E4E4E4',
            gridlines: {
                color: '#E4E4E4',
                count: 4
            }
        },*/
        /*pointSize: 4,
        colors: ['#6C6C6C', '#2E9DF3', '#F3CA42', '#41B9AE', '#E20055']*/
      }
    }
  },
  props: [
      'MsgItems'
    ],
  methods: {
    inputChanged (upd) {
      if (upd.key === 'FilterPI') {
        if (upd.val.length === 16) {
          this.$refs.filterForm.setDisabled('OnlySummary',false)
        }
        else {
          this.formDataObj.OnlySummary = false
          this.$refs.filterForm.refreshModelVar('OnlySummary')
          this.$refs.filterForm.setDisabled('OnlySummary',true)
        }
      }
    },
    cancel: function () {
      this.CancelCallback();
    },
    PopupDisplay: function (msg) {
      this.displayingMsg = msg
      this.showMsg = true;
    },
    /*onChartReady: function (chart, google) {
      let data = new google.visualization.DataTable();
      // let data = google.visualization.arrayToDataTable(this.chartData)
      // eslint-disable-next-line
      console.log(data)
      let columns = [
        {name: 'Date', type: 'date'},
        {name: '開放預約數', type: 'number'},
        {name: '銷售數', type: 'number'},
        {name: '退票數', type: 'number'},
        {name: '使用數', type: 'number'},
        {name: '平均評價數', type: 'number'}
      ]
      for (let i=0; i< columns.length; i++) {
        data.addColumn(columns[i].type, columns[i].name);
      }
      data.addRows({'Date':'2018-01-01','開放預約數':1,'開放預約數':1,'開放預約數':1,'開放預約數':1,'開放預約數':1})
      //$.each(columns, function(i, column) {
      //  data.addColumn(column.type, column.name);
      //});
      // data.addRows(this.chartData);
      chart.draw(data, this.chartOptions)
    },*/
    getChartData: function () {
      let rptParam = {
        'module':'integration',
        'method':'getApiLogReport',
        // 'role': 'nineder',
        // 'rpt_start_date':'',
        // 'rpt_end_date':'',
        'filter_pi': this.formDataObj.FilterPI,
        'export_as_chart_data':1,
        'not_group_by_date': this.formDataObj.OnlySummary?1:0,
        // 'role': 'nineder' //special parameter to custom apikey injection
      }
      // rptParam = this.$bus.getApiParam('nineder', rptParam)
      /*genericApiResult(rptParam).then(data => {
          if (data.ok === 0) {
            alert(data.msg)
            return
          }
          // eslint-disable-next-line
          // console.log(data)
          this.chartData = data.data
        }, reject => {
          alert('error ' + reject)
        }
      )*/
      this.$bus.apiCall(rptParam, function (data, vm) {
        if (data.ok === 0) {
            //alert(data.msg)
            //vm.$bus.fnShowInfo(data.msg,true)
            return
          }
          // eslint-disable-next-line
          // console.log(data)
          vm.chartData = data.data
      },this)
    },
    forceSync () {
      let rptParam = {
        'module':'admin_manage',
        'method':'forceSyncNow',
      }
      this.$bus.apiCall(rptParam, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.fnShowInfo('排程手動呼叫完畢')
      },this)
    }
  },
  computed: {
    PIValidated () {
      if (this.FilterPI.length === 16) {
        return true
      }
      else {
        return false
      }
    } 
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    this.getChartData()
  },
  watch:{
    'FilterPI'(newVal){
        //to work with changes in prop=>被登入失敗清空session時回登入
        if (newVal.length !== 16) {
          this.OnlySummary = false
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart1 {
  width:100%;
  height:70vh;
  border-style:ridge;
}
</style>
